var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600",
        scrollable: "",
        persistent: "",
        eager: ""
      },
      on: {
        keydown: function keydown($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.close($event)
        },
        "click:outside": _vm.close
      },
      model: {
        value: _vm.dialogProxy,
        callback: function callback($$v) {
          _vm.dialogProxy = $$v
        },
        expression: "dialogProxy"
      }
    },
    [
      _c(
        "v-card",
        {
          staticClass: "app-card card-borderless"
        },
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Disable Protection ")]
          ),
          _c(
            "v-card-text",
            {
              staticClass: "pt-2 pb-3"
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _vm._v(
                        ' You are going to disable protection for "' +
                          _vm._s(_vm.path) +
                          '". Please, confirm your action. '
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "justify-content-end pb-4 pt-0"
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.removeProtection
                  }
                },
                [_vm._v("Confirm")]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }